import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TarefaRoutingModule } from './tarefa-routing.module';
import { ListaComponent } from './pages/lista/lista.component';
import { NovaComponent } from './pages/nova/nova.component';
import { DetalhesComponent } from './pages/detalhes/detalhes.component';
import { AgendaComponent } from './pages/agenda/agenda.component';
import {ComponentesModule} from "../../../core/componentes/componentes.module";
import {FormsModule} from "@angular/forms";
import {NgxPaginationModule} from "ngx-pagination";
import {DragDropModule} from "@angular/cdk/drag-drop";
import {NgSelectModule} from "@ng-select/ng-select";
import {NgxMaskDirective} from "ngx-mask";


@NgModule({
    declarations: [
        ListaComponent,
        NovaComponent,
        DetalhesComponent,
        AgendaComponent
    ],
    exports: [
        DetalhesComponent,
        NovaComponent
    ],
    imports: [
        CommonModule,
        TarefaRoutingModule,
        ComponentesModule,
        FormsModule,
        NgxPaginationModule,
        DragDropModule,
        NgSelectModule,
        NgxMaskDirective
    ]
})
export class TarefaModule { }
